export default "__VITE_ASSET__a4nFNUZM__"